import { Component, componentMixin } from '@resn/gozer-core/component';

import ThreeObjectMixin from '@resn/gozer-core-mixins/three-object';
import ResizeService from '@resn/gozer-services/resize-service';
import { autobind } from 'core-decorators';
import getPixelRatio from 'utils/get-pixel-ratio';

import { COLORS } from 'core/constants';
import { OrthographicCamera, PerspectiveCamera, Scene, WebGLRenderer } from 'three';
import { pane } from '@resn/gozer-misc';

@componentMixin(ThreeObjectMixin)
class Renderer extends Component {
    static instance;
    static renderer;

    options = {
        appendTo: null,
        isSingleton: true,
        useViewportSize: true,
        antialias: false,
    };

    props = {
        active: false,

        width: 1,
        height: 1,
        size: (props) => ({
            width: props.width,
            height: props.height,
        }),
    };

    async onSetup() {
        const { antialias } = this.options;
        const { width, height } = this.props.size;

        const renderer = (this.renderer = new WebGLRenderer({ antialias }));
        renderer.setSize(width, height);
        renderer.setClearColor(COLORS.DARK_BLUE, 1);
        renderer.autoClear = false;
        renderer.clear();

        if (__DEV__ && pane) {
            this.stats = '';
            setInterval(() => {
                requestAnimationFrame(() => {
                    this.stats = JSON.stringify(
                        {
                            triangles: renderer.info.render.triangles,
                            calls: renderer.info.render.calls,
                            textures: renderer.info.memory.textures,
                            geometries: renderer.info.memory.geometries,
                            length: renderer.info.programs.length,
                        },
                        null,
                        ' ',
                    );
                });
            }, 1000);

            (await pane).addMonitor(this, 'stats', {
                multiline: true,
                lineCount: 5,
            });
        }

        this.scene = new Scene();

        if (this.options.appendTo) this.options.appendTo.appendChild(renderer.domElement);

        this.orthographicCamera = new OrthographicCamera(1, 1, 1, 1, 1, 10);
        this.orthographicCamera.position.set(0, 0, 5);

        this.perspectiveCamera = new PerspectiveCamera(35, width / height, 1, 20);
        this.perspectiveCamera.position.set(0, 0, 5);
        /* 
        this.controls = new OrbitControls(this.perspectiveCamera, this.options.appendTo);
        this.controls.enabled = false;
 */
        if (this.options.isSingleton) Renderer.instance = this;
        ResizeService.add(this.onResize, true);
    }

    clear() {
        this.renderer.clear();
    }

    render() {}

    @autobind
    onResize() {
        if (this.options?.useViewportSize) {
            const { width, height } = ResizeService.size;
            this.props.width = width;
            this.props.height = height;
        }
    }

    setSize({ width, height }) {
        this.renderer.setSize(width, height);
        this.renderer.setPixelRatio(getPixelRatio());

        this.orthographicCamera.left = -width / 2;
        this.orthographicCamera.right = width / 2;
        this.orthographicCamera.top = height / 2;
        this.orthographicCamera.bottom = -height / 2;
        this.orthographicCamera.updateProjectionMatrix();

        this.perspectiveCamera.aspect = width / height;
        this.perspectiveCamera.updateProjectionMatrix();
    }

    getRenderer() {
        return this.renderer;
    }

    static getInstance() {
        return Renderer.instance;
    }

    static getRenderer() {
        return Renderer.instance.renderer;
    }
}

export default Renderer;
